import * as React from 'react';
import { Container } from 'types/Watchlist';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateWatchListWithDeleted } from 'services/clients/watchList';
import { useSegment } from 'common/hooks/segment';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { SHIPMENTS_QUERY_PARAMS } from 'pages/Shipments/params';
import { TitleBar } from './TitleBar';
import { ContainerDetails } from './ContainerDetails';

interface Props {
  container: Container;
}

export const Header: React.FC<Props> = (props) => {
  const { container } = props;
  const { track } = useSegment();
  const queryClient = useQueryClient();
  const { setSearchParams } = useCustomSearchParams(SHIPMENTS_QUERY_PARAMS);

  const deleteContainer = useMutation(
    async (transactionId: string) => {
      return updateWatchListWithDeleted({
        transactionIds: [transactionId],
        updateDeleted: true,
      });
    },
    {
      onSuccess: (_, c) => {
        queryClient.invalidateQueries(['watchList']);
        queryClient.invalidateQueries(['watchListCount']);
        setSearchParams({ focusedContainer: null });
        track(
          'Container Deleted',
          {
            feature: 'watchlist',
            source: 'detailDrawer',
            nbContainers: 1,
            containers: [c],
          },
          { includeCompany: true, includeUser: true }
        );
      },
    }
  );

  return (
    <div className="space-y-2">
      <TitleBar container={container} onDelete={deleteContainer.mutate} className="flex-grow" />
      <ContainerDetails container={container} />
    </div>
  );
};
Header.displayName = 'Shipments.DetailDrawer.Header';
